export default "__VITE_ASSET__BeQHxsS4__"